import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, themeQuartz } from 'ag-grid-community';
import '../../config/agGridConfig'; // Register AG Grid modules
import { adminAPI } from '../../services/api';
import '../../styles/AdminGlobal.css';
import './Admin.css';

const CustomerManagement: React.FC = () => {
  const [customers, setCustomers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', width: 70, sortable: true },
    { field: 'username', headerName: 'Username', sortable: true, filter: true, width: 150 },
    { field: 'email', headerName: 'Email', sortable: true, filter: true, flex: 1 },
    { field: 'phone', headerName: 'Phone', sortable: true, width: 130 },
    { field: 'city', headerName: 'City', sortable: true, width: 120 },
    { field: 'created_at', headerName: 'Joined', sortable: true, width: 120, valueFormatter: (p: any) => new Date(p.value).toLocaleDateString() },
    { 
      headerName: 'Actions',
      width: 60,
      pinned: 'right',
      lockPosition: true,
      suppressMovable: true,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => {
        const buttonStyle = {
          border: 'none',
          borderRadius: '6px',
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '16px',
          transition: 'all 0.2s ease',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        };
        
        return (
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <button 
              onClick={() => console.log('View customer:', params.data)}
              title="View Customer"
              style={{ 
                ...buttonStyle,
                backgroundColor: '#6c757d',
                color: 'white'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              👁️
            </button>
          </div>
        );
      }
    }
  ];

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      setLoading(true);
      const response = await adminAPI.getCustomers();
      const data = response.data || response;
      const customersList = Array.isArray(data) ? data : (data.results || []);
      setCustomers(customersList);
    } catch (error) {
      console.error('Failed to load customers:', error);
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  // Ensure customers is always an array before filtering
  const customersArray = Array.isArray(customers) ? customers : [];
  const filteredCustomers = customersArray.filter(customer =>
    customer.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    customer.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    customer.phone?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="admin-page">
      <div className="management-header">
        <div>
          <h3>Customer Management</h3>
          <p>View and manage customer accounts</p>
        </div>
        <div className="management-actions">
          <button className="btn btn-secondary" onClick={loadCustomers}>
            🔄 Refresh
          </button>
        </div>
      </div>
      
      <div className="ag-grid-wrapper">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search customers by name, email, or phone..."
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
        <div className="results-info">
          <span>{filteredCustomers.length}</span> customers found
        </div>
      
        <div className="ag-grid-container">
          <AgGridReact

            theme={themeQuartz}
            rowData={filteredCustomers || []}
            columnDefs={columnDefs}
            pagination={true}
            paginationPageSize={20}
            loading={loading}

            defaultColDef={{
              resizable: true,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerManagement;
